import { RouteBase } from "./route-base.model";

export class AirTariffRoute extends RouteBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    protected comment: string,
    public weightPriceLt45?: number,
    public weightPriceGt45?: number,
    public weightPriceGt100?: number,
    public weightPriceGt300?: number,
    public weightPriceGt500?: number,
    public weightPriceGt1000?: number,
  ) {
    super(id, discriminator, comment);
  }
}
